import { initCustomDots } from './custom-dots';

export const initClients = () => {
  initCustomDots('.clients');
};